import { useRef, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loadUserProfile } from "../../redux/actions/authActions";

const FormModalUpdatePrestaInfosPerso = ({ onClose }) => {

    const { token } = useSelector((state) => state.auth);
    const profilPrestataire = useSelector((state)=>state.profil.prestataire);

    const [formData, setFormData] = useState({
        nom: profilPrestataire.lastNamePrestataire,
        prenom: profilPrestataire.firstNamePrestataire,
        dateOfBirthRepresentant: profilPrestataire.dateNaissancePrestataire,
        phoneNumber: profilPrestataire.telephonePrestataire,
        siteWeb: profilPrestataire.siteWeb,
    });
    const [updateSuccess, setUpdateSuccess] = useState(false);
    const [errors, setErrors] = useState({});
    const apiUrl = process.env.REACT_APP_API_URL;
    const [photoPreview, setPhotoPreview] = useState(
        apiUrl + "/api/files/?categorie=photosPrestataires&file=" + profilPrestataire?.photoProfilPrestataire || ""
    );
    const photoInputRef = useRef(null);

    const dispatch = useDispatch();
  
    const handleFileChange = (e, type) => {
        const file = e.target.files[0];
        if (!file) return;

        if (type === "photoProfil") {
            setFormData((prev) => ({ ...prev, photoProfil: file }));
            setPhotoPreview(URL.createObjectURL(file));
        }

    };

    const handleRemoveFile = (type) => {
        if (type === "photoProfil") {
            if (photoPreview.startsWith("blob:")) URL.revokeObjectURL(photoPreview);
            setFormData((p) => ({ ...p, photoProfil: null }));
            setPhotoPreview(
                profilPrestataire.photoProfilPrestataire
                    ? apiUrl + "/api/files/?categorie=photosPrestataires&file=" + profilPrestataire.photoProfilPrestataire
                    : ""
            );
            if (photoInputRef.current) photoInputRef.current.value = "";
        }


    };
    const validateField = (name, value) => {
        let fieldErrors = { ...errors };

        switch (name) {
            case "nom":
                if (!value || value.length < 2) fieldErrors.nom = "Le nom doit contenir au moins 2 caractères";
                else delete fieldErrors.nom;
                break;

            case "prenom":
                if (!value || value.length < 2) fieldErrors.prenom = "Le prénom doit contenir au moins 2 caractères";
                else delete fieldErrors.prenom;
                break;

            case "dateOfBirthRepresentant":
                if (!value) fieldErrors.dateOfBirthRepresentant = "Le champ Date de Naissance est requis";
                else {
                    const birthDate = new Date(value);
                    const today = new Date();
                    let age = today.getFullYear() - birthDate.getFullYear();
                    const m = today.getMonth() - birthDate.getMonth();
                    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) age--;
                    if (age < 18) fieldErrors.dateOfBirthRepresentant = "Vous devez avoir au moins 18 ans.";
                    else delete fieldErrors.dateOfBirthRepresentant;
                }
                break;

            case "phoneNumber":
                if (!/^\d{10}$/.test(value)) fieldErrors.phoneNumber = "Le numéro doit contenir exactement 10 chiffres";
                else delete fieldErrors.phoneNumber;
                break;

            default:
                break;
        }

        setErrors(fieldErrors);
    };



    const isFormValid = !errors.nom && !errors.prenom && !errors.dateOfBirthRepresentant && !errors.phoneNumber && formData.nom && formData.prenom && formData.dateOfBirthRepresentant && formData.phoneNumber;
    const handleChange = (e) => {
        const { name, value } = e.target;

        let newValue = value;

        setFormData((prev) => ({ ...prev, [name]: newValue }));
        validateField(name, newValue);
    };


    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const submitData = new FormData();

            // Champs basiques
            Object.keys(formData).forEach((key) => {
                if (
                    formData[key] !== null &&
                    formData[key] !== undefined &&
                    formData[key] !== ""
                ) {
                    submitData.append(key, formData[key]);
                }
            });
            if (formData.photoProfil instanceof File) {
                submitData.append("photoProfil", formData.photoProfil);
            }

            const response = await fetch(`${apiUrl}/api/updateProfil/prestataire`, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                body: submitData,
            });

            const result = await response.json();

            if (!response.ok) {
                console.error(result);
                alert(result.error || "Erreur lors de la mise à jour");
                return;
            }

            setUpdateSuccess(true);

            // mise à jour Redux auth
            dispatch(loadUserProfile(token));


            // fermer la modal après succès
            setTimeout(() => {
                onClose();
            }, 800);

        } catch (error) {
            console.error("Erreur fetch:", error);
            alert("Impossible d’enregistrer les modifications.");
        }
    };

    return (
        <div className="inscriptionModalOverlay">
            <div className="inscriptionModal">
                <button className="inscriptionModalClose" onClick={onClose}>×</button>

                <h2>Mise à jour du Profil</h2>

                <form onSubmit={handleSubmit}>
                    <h3>Représentant légal</h3>
                    <div className="inscriptionPrestataireModal-input-form">
                        <label>Nom</label>
                        <input type="text" name="nom" value={formData.nom} onChange={handleChange} required />
                        {errors.nom && <p className="error-text">{errors.nom}</p>}
                    </div>
                    <div className="inscriptionPrestataireModal-input-form">
                        <label>Prénom</label>
                        <input type="text" name="prenom" value={formData.prenom} onChange={handleChange} required />
                        {errors.prenom && <p className="error-text">{errors.prenom}</p>}
                    </div>
                    <div className="inscriptionPrestataireModal-input-form">
                        <label>Date de naissance</label>
                        <input type="date" name="dateOfBirthRepresentant" value={formData.dateOfBirthRepresentant} onChange={handleChange}
                            max={new Date(new Date().setFullYear(new Date().getFullYear() - 18)).toISOString().split("T")[0]} />
                        {errors.dateOfBirthRepresentant && <p className="error-text">{errors.dateOfBirthRepresentant}</p>}
                    </div>
                    <div className="inscriptionPrestataireModal-input-form">
                        <label>N° de téléphone</label>
                        <input type="text" name="phoneNumber" value={formData.phoneNumber} onChange={handleChange} required />
                        {errors.phoneNumber && <p className="error-text">{errors.phoneNumber}</p>}
                    </div>
                    <div className="inscriptionPrestataireModal-input-form">
                        <label>Site Web</label>
                        <input type="text" name="siteWeb" value={formData.siteWeb} onChange={handleChange} required />
                    </div>
                    <div className="inscriptionClientModal-input-form">
                        <label>Photo de profil</label>

                        {/* Input caché */}
                        <input
                            ref={photoInputRef}
                            type="file"
                            accept="image/*"
                            style={{ display: "none" }}
                            onChange={(e) => handleFileChange(e, "photoProfil")}
                        />

                        {photoPreview ? (
                            <div
                                style={{
                                    position: "relative",
                                    width: "120px",
                                    height: "120px",
                                    margin: "0 auto",
                                    cursor: "pointer",
                                }}
                            >
                                {/* IMAGE */}
                                <img
                                    src={photoPreview}
                                    alt="Preview"
                                    style={{
                                        width: "100%",
                                        height: "100%",
                                        borderRadius: "50%",
                                        objectFit: "cover",
                                    }}
                                    onClick={() => photoInputRef.current.click()}
                                />

                                {/* BOUTON CROIX */}
                                <div
                                    onClick={() => handleRemoveFile("photoProfil")}
                                    style={{
                                        position: "absolute",
                                        top: "-6px",
                                        right: "-6px",
                                        width: "26px",
                                        height: "26px",
                                        borderRadius: "50%",
                                        background: "#ff4d4d",
                                        color: "white",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        cursor: "pointer",
                                        fontWeight: "bold",
                                        fontSize: "18px",
                                        boxShadow: "0 0 5px rgba(0,0,0,0.3)",
                                        zIndex: 999,
                                    }}
                                >
                                    ×
                                </div>
                            </div>
                        ) : (
                            // L’input apparaît seulement si aucune photo
                            <button
                                type="button"
                                onClick={() => photoInputRef.current.click()}
                                className="btn-upload"
                            >
                                Choisir une photo
                            </button>
                        )}
                    </div>


                    <div className="inscriptionClientModal-actions">
                        <button type="submit" disabled={!isFormValid}>ENREGISTRER</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default FormModalUpdatePrestaInfosPerso;
